import { fetchApi } from '@/lib/api';
import { factoryInit, queryString, type FactoryRequestOptions } from '@/lib/factory-request';
import type { TaskPeopleTime, UsagePeriod, UsageReport, WorkUsage } from '@shared/types/factory';

/** LLM usage (T-12): what the agents spent on a task or a run, and across projects. */

/** A task's agent usage (with people's time on it, T-102), or one run's, in the current project. */
export function getWorkUsage(by: { task_id: string } | { run_id: string }, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ usage: WorkUsage; people?: TaskPeopleTime }>(`/usage${queryString(by)}`, factoryInit(opts));
}

/**
 * Usage across every project the caller can see, over a period, with people's time beside it (T-102);
 * `project` narrows it to one project's id, or 'across' for people's time outside any project.
 */
export function getUsageReport(period: UsagePeriod, project: string | null, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ report: UsageReport }>(`/usage-all${queryString({ period, project: project ?? undefined })}`, factoryInit(opts));
}
